












































import { Component, Vue } from "vue-property-decorator";
import { purePcVerify } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public code: any = "";
  public certificateData: any = {
    id: 1,
  };
  public created() {
    if (this.$route.query.id) {
      this.code = this.$route.query.id;
      this.search();
    }
  }
  public async search() {
    const res = await purePcVerify({
      id: this.code.slice(9),
    });
    if (res.code == 200) {
      res.data.effect_start_at = res.data.effect_start_at.substring(0, 10);
      res.data.effect_end_at = res.data.effect_end_at.substring(0, 10);
      this.certificateData = res.data
      this.certificateData.issued = this.certificateData.effect_start_at.replaceAll('-', '.');
    } else {
      this.$Message.error(res.msg);
    }
  }
}
